export default __webpack_public_path__ + "static/0-0d16ca4a9ae6ba9cd7affa03fbc4e07a.png";